import styled from "styled-components";

export const Wrapper = styled.div`
  box-shadow: ${({ theme }) => `0px 4px 8px ${theme.default.color.text.light}`};
  padding: 0 24px;
  border-radius: 7px;
`;

export const Title = styled.p`
  color: ${({ theme }) => theme.default.color.primary};
  font-family:  ${({ theme }) => theme.default.fontFamily.secondaryFont};
  font-size: 13px;
  font-style: normal;
  font-weight: 900;
  line-height: 16px;
  letter-spacing: 0.05em;
  text-align: left;
  padding-top: 22px;
  margin-bottom: 0;
  text-transform: uppercase;
`;
export const Subtitle = styled.p`
 font-family:  ${({ theme }) => theme.default.fontFamily.secondaryFont};
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
  margin-top: 7px;
`;

export const Body = styled.div`
  font-family:  ${({ theme }) => theme.default.fontFamily.secondaryFont};
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 0;
`;
